export const Divider = () => {
	return <div class="h-px w-full bg-[#EFEFF0]" />;
};
